module.exports = __webpack_public_path__ + "img/helene_h.da917ad4.png";